import http from "./httpService";
//import { ROOT_URL } from "../config.json";
import jwtDecode from "jwt-decode";
import ReactGA from 'react-ga'
//const apiEndpoint = ROOT_URL + "/oauth/token";
const apiEndpoint = `oauth/token`;
//const tokenKey = "token";
const grant_type = "password";
const client_id = process.env.REACT_APP_CLIENT_ID;
const client_secret = process.env.REACT_APP_CLIENT_SECRET;
const scope = "*";

export async function login(email, password) {
    const username = email;
    // console.log('auth podaci: ', username, password, grant_type, client_id, client_secret, scope)
    const response = await http.post(apiEndpoint, {username, password, grant_type, client_id, client_secret, scope},
        {headers: {authorization: getJwt()}});
    // console.log('auth response: ', response)
    const jwt = await response.data.access_token;
    //http.setJwt('Bearer ' + jwt);
    await localStorage.setItem('token', 'Bearer ' + jwt);
    const user = await http.get('api/user_info', {headers: {authorization: getJwt()}});
    await localStorage.setItem('user_id', user.data.data.id);
}

//export function loginWithJwt(jwt) {
//    //localStorage.setItem(tokenKey, jwt);
//}

export function logout() {
    // ReactGA.event({
    //     category: 'Click',
    //     action: 'Log Out',
    //     userId: getCurrentUserId(),
    //     label: '',
    //     nonInteraction: true
    // });
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('email');
    localStorage.removeItem('user_name');
    localStorage.removeItem('source_clicked');
    localStorage.removeItem('feed_id');
    localStorage.removeItem('selectedTeam');
    localStorage.removeItem('navigateBackTo');
    localStorage.removeItem('main_subs');
    localStorage.removeItem('fb_subs_type');
    localStorage.removeItem('allowedTrial');
    localStorage.removeItem('predefinedPlan');
    localStorage.removeItem('workspaceName');
    localStorage.removeItem('sel');
    localStorage.removeItem('range');

    //removing UTM parameters
    localStorage.removeItem('utmTracking');
    localStorage.removeItem('utmCampaign');
    localStorage.removeItem('utmSource');
    localStorage.removeItem('utmMedium');
    localStorage.removeItem('utmTerm');
    localStorage.removeItem('utmContent');
    localStorage.removeItem('customName');
    localStorage.removeItem('customValue');


}

export function setCurrentUserName(user_name) {
    localStorage.setItem('user_name', user_name);
}

export function getCurrentUserName() {
    //try {
    return localStorage.getItem('user_name');
    //} catch (ex) {
    //    return null;
    //}
}

export function getCurrentUserEmail() {
    return localStorage.getItem('user_email')
}

export function getCurrentUserId() {
    try {
        return localStorage.getItem('user_id');
    } catch (ex) {
        return null;
    }
}

export function getJwt() {
    //console.log('jwt: ', localStorage.getItem('token'))
    return localStorage.getItem('token');
}

//export async function toggleConnect (e){
//    //console.log("toggleConnect e.target ", e.target);
//    //console.log("toggleConnect e.target.title ", e.target.title);
//    //
//    //console.log("toggleConnect e.target.attributes.value.nodeValue ", e.target.attributes.value.nodeValue);
//    //this.props.updatePageConnectionToBot(this.props.message.id, e.target.id, e.target.value, e.target.name);
//    //const user_id = getCurrentUserId();
//    //const ROOT_URL = process...env.REACT_APP_ROOT_URL;
//    const FB_URL = 'https://graph.facebook.com/v2.12/';
//    let pg_id= e.target.id;
//    let pg_token= e.target.attributes.value.nodeValue;
//    let feed_id= e.target.attributes.name.nodeValue;
//    let page_connected= e.target.title;
//
//    //console.log("toggleConnect ", user_id, pg_id,  pg_token, page_connected, feed_id);
//
//    //console.log("IN DISPATCH", id, pg_id,  pg_token, page_connected);
//    var url_facebook_graph = FB_URL+pg_id+'/subscribed_apps?access_token='+pg_token;
//    //var headers_facebook_graph = { ContentType: "application/json" };
//    var url_facebook_get_started = FB_URL+'me/thread_settings?access_token='+pg_token;
//
//    var headers_get_started = { ContentType: "application/json" };
//    //page_connected = "Connected";
//    let paramsToSend = {
//        page_connected: page_connected,
//        feed_id: feed_id
//    };
//    //console.log("Main paramsToSend ", paramsToSend);
//    try
//    {
//        //const result = await http.get('api/activate-user/'+getCurrentUserId(), {headers: {authorization: getJwt()}});
//        //const data = result.data.data;
//        if(page_connected !== "Connected")
//        {
//            const result = await axios.post(url_facebook_graph, {
//                headers: {
//                    'Access-Control-Allow-Origin': '*'
//                }
//            });
//            //const data = result;
//            //console.log("toggleConnect url_facebook_graph result", result);
//            if (!result) {
//                toastr.error("Facebook api connecting app problem. :(  Please log in again.");
//                //this.props.history.push('/logout');
//            }
//            else {
//                page_connected = "Connected";
//                paramsToSend = {
//                    page_connected: page_connected,
//                    feed_id: feed_id
//                };
//                var url_api = '/api/user/'+getCurrentUserId()+'/page/'+pg_id;
//                var headers_def = { authorization: getJwt() };
//
//                var params_start =  {
//                    "setting_type": "call_to_actions",
//                    "thread_state": "new_thread",
//                    "call_to_actions": [
//                        {
//                            "payload": "Start"
//                        }
//                    ]
//                };
//
//                const res = await http.patch(url_api, paramsToSend, { headers: headers_def });
//                const data = res.data.data;
//                //console.log("then data", data);
//                if(!data)
//                {
//                    toastr.error("res id does not match. :(  Please log in again.");
//                    this.props.history.push('/logout');
//                }
//                else
//                {
//                    //this.setState({user: data});
//                    let user = data;
//                    //console.log("Main componentDidMount user",user);
//                    this.setState({user: user});
//                    //const res_get_started = await axios.post(url_facebook_get_started, params_start, {headers: headers_get_started});
//                    await axios.post(url_facebook_get_started, params_start, {headers: headers_get_started});
//                    //const data_get_started = res.data.data;
//                    //console.log("url_facebook_get_started", res_get_started);
//                }
//            }
//        }
//        else
//        {
//            const result = axios.delete(url_facebook_graph);
//            //const data = result;
//            //console.log("toggleConnect url_facebook_graph result else", result);
//            if (!result) {
//                toastr.error("Facebook api disconnecting app problem.. :(  Please log in again.");
//                //this.props.history.push('/logout');
//            }
//            else
//            {
//                page_connected = "Not Connected";
//                paramsToSend = {
//                    page_connected: page_connected,
//                    feed_id: feed_id
//                };
//                url_api = '/api/user/' + getCurrentUserId() + '/page/' + pg_id;
//                headers_def = {authorization: getJwt()};
//
//                const res = await http.patch(url_api, paramsToSend , {headers: headers_def});
//                const data = res.data.data;
//                //console.log("then else data", data);
//                if(!data)
//                {
//                    toastr.error("res removing id does not match. :(  Please log in again.");
//                    this.props.history.push('/logout');
//                }
//                else
//                {
//                    //this.setState({message: data});
//                    let user = data;
//                    this.setState({user: user});
//                }
//            }
//        }
//
//        //this.setState({message: data});
//    }
//    catch (ex)
//    {
//        if (ex.response && ex.response.status === 404)
//            toastr.error("Something went wrong... Please refresh and try again.");
//        if (ex.response && ex.response.status === 401)
//        {
//            //    let errors = { ...this.state.errors }
//            //console.log(ex.response.data);
//            toastr.error(ex.response.data.message);
//            //window.location = "/";
//            this.props.history.push('/logout');
//        }
//    }
//}

export default {
    login,
    //loginWithJwt,
    logout,
    setCurrentUserName,
    getCurrentUserName,
    getCurrentUserId,
    getJwt,
    getCurrentUserEmail
    //toggleConnect
};
